import axios from '@/api/axios'


const getListCashbox = (data) => {
    return axios
        .post('/admin/cashbox/list-cashbox', {cashbox: data})
        .then(response => response.data)
}

const getCashboxDetail = (data) => {
    return axios
        .post('/admin/cashbox/cashbox-detail', {cashbox: data})
        .then(response => response.data)
}

const openShift = (data) => {
    return axios
        .post('/admin/cashbox/open-shift', {cashbox: data})
        .then(response => response.data)
}

const closeShift = (data) => {
    return axios
        .post('/admin/cashbox/close-shift', {cashbox: data})
        .then(response => response.data)
}

const closeAcq = (data) => {
    return axios
        .post('/admin/cashbox/close-acq', {cashbox: data})
        .then(response => response.data)
}

const cashIn = (data) => {
    return axios
        .post('/admin/cashbox/cash-in', {cashbox: data})
        .then(response => response.data)
}

const cashOut = (data) => {
    return axios
        .post('/admin/cashbox/cash-out', {cashbox: data})
        .then(response => response.data)
}

const saleReceipt = (data) => {
    return axios
        .post('/admin/cashbox/sale-receipt', {cashbox: data})
        .then(response => response.data)
}

const makePayment = (data) => {
    return axios
        .post('/admin/cashbox/make-payment', {cashbox: data})
        .then(response => response.data)
}

const multiplePayment = (data) => {
    return axios
        .post('/admin/cashbox/multiple-payment', {cashbox: data})
        .then(response => response.data)
}

const multiplePaymentMany = (data) => {
    return axios
        .post('/admin/cashbox/multiple-payment-many', {cashbox: data})
        .then(response => response.data)
}

const xReport = (data) => {
    return axios
        .post('/admin/cashbox/x-report', {cashbox: data})
        .then(response => response.data)
}
const cancelReceipt = (data) => {
    return axios
        .post('/admin/cashbox/cancel-receipt', {cashbox: data})
        .then(response => response.data)
}

const zReport = (data) => {
    return axios
        .post('/admin/cashbox/z-report', {cashbox: data})
        .then(response => response.data)
}

const makePaymentPart = (data) => {
    return axios
        .post('/admin/cashbox/make-payment-part', {cashbox: data})
        .then(response => response.data)
}

const saleReceiptPart = (data) => {
    return axios
        .post('/admin/cashbox/sale-receipt-part', {cashbox: data})
        .then(response => response.data)
}

const saleReceiptBuyer = (data) => {
    return axios
        .post('/admin/cashbox/make-payment-buyer', {cashbox: data})
        .then(response => response.data)
}

//----------------------------------------------------------------------------

const getListTerminals = (data) => {
    return axios
        .post('/admin/cashbox/terminals-list', {cashbox: data})
        .then(response => response.data)
}

const createTerminals = (data) => {
    return axios
        .post('/admin/cashbox/terminals-create', {cashbox: data})
        .then(response => response.data)
}

const createCashbox = (data) => {
    return axios
        .post('/admin/cashbox/cashbox-create', {cashbox: data})
        .then(response => response.data)
}

const getListBanks = (data) => {
    return axios
        .post('/admin/cashbox/list-banks', {cashbox: data})
        .then(response => response.data)
}

const getListBanksAccounts = (data) => {
    return axios
        .post('/admin/cashbox/list-banks-accounts', {cashbox: data})
        .then(response => response.data)
}

export default {
    getListCashbox,
    getCashboxDetail,
    openShift,
    closeShift,
    closeAcq,
    cashIn,
    cashOut,
    saleReceipt,
    makePayment,
    multiplePayment,
    xReport,
    cancelReceipt,
    zReport,
    makePaymentPart,
    saleReceiptPart,
    multiplePaymentMany,
    saleReceiptBuyer,
    getListTerminals,
    createTerminals,
    createCashbox,
    getListBanks,
    getListBanksAccounts
}